import { render, staticRenderFns } from "./EditSuggestion.vue?vue&type=template&id=42e9bf70&scoped=true&"
import script from "./EditSuggestion.vue?vue&type=script&lang=js&"
export * from "./EditSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e9bf70",
  null
  
)

export default component.exports